"use strict";

var _classCallCheck = require("/home/abhishek/Documents/Macrometa/demos/tutorial-jamstack-pollingapp/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/abhishek/Documents/Macrometa/demos/tutorial-jamstack-pollingapp/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Status;

(function (Status) {
  Status["OK"] = "OK";
  Status["WARN"] = "WARN";
  Status["ERROR"] = "ERROR";
})(Status = exports.Status || (exports.Status = {}));

var EntityType;

(function (EntityType) {
  EntityType["COLLECTION"] = "COLLECTION";
  EntityType["GRAPH"] = "GRAPH";
  EntityType["AUTH"] = "AUTH";
  EntityType["STREAM"] = "STREAM";
  EntityType["GEOFABRIC"] = "GEOFABRIC";
})(EntityType = exports.EntityType || (exports.EntityType = {}));

var ActionType;

(function (ActionType) {
  ActionType["CREATE"] = "CREATE";
  ActionType["UPDATE"] = "UPDATE";
  ActionType["DELETE"] = "DELETE";
  ActionType["EXECUTE"] = "EXECUTE";
  ActionType["LOGIN"] = "LOGIN";
})(ActionType = exports.ActionType || (exports.ActionType = {}));

var Event = /*#__PURE__*/function () {
  function Event(connection, entityName, eventId) {
    _classCallCheck(this, Event);

    this._connection = connection;
    this.entityName = entityName;
    this.eventId = eventId;
  }

  _createClass(Event, [{
    key: "create",
    value: function create(requestObject) {
      var _this = this;

      var status = requestObject.status,
          description = requestObject.description,
          entityType = requestObject.entityType,
          details = requestObject.details,
          action = requestObject.action,
          attributes = requestObject.attributes;
      return this._connection.request({
        method: "POST",
        path: "/events",
        body: {
          status: status,
          description: description,
          entityName: this.entityName,
          entityType: entityType,
          details: details,
          action: action,
          attributes: attributes
        }
      }, function (res) {
        _this.eventId = res.body._key;
        return res.body;
      });
    }
  }, {
    key: "details",
    value: function details() {
      if (!this.eventId) {
        throw new Error("Event ID is not set. Either provide while creating the handler or create a new event.");
      }

      return this._connection.request({
        method: "GET",
        path: "/events/".concat(this.eventId)
      }, function (res) {
        return res.body;
      });
    }
  }]);

  return Event;
}();

exports.Event = Event;